
define('text!common/views/ui/loading.html',[],function () { return '<div class="pamplemousse">\n    <div class="pamplemousse__pip"><i></i></div>\n    <div class="pamplemousse__pip"><i></i></div>\n    <div class="pamplemousse__pip"><i></i></div>\n</div>\n';});

